import React, { useEffect, useState } from 'react';
import { FaAngleUp, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { TbFlower } from 'react-icons/tb';
import { motion } from 'motion/react';
import Card from '../components/Bullshit/Card';
import InfoCard from '../components/Info/InfoCard';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExtendedCancellationPeriod from '../components/ExtendCancellationPeroid/ExtendedCancellationPeriod (2)';
import CancellationPeriod from '../components/CancellationPeroid/CancellationPeriod';
import { useDispatch, useSelector } from 'react-redux';
import { fetchposts } from '../redux/apiCalls/calenderApiCall';
import { insertPayment } from '../redux/slices/paySlice';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';
import { fetchCuppon } from '../redux/slices/CupponSlice';
import { creatOrder } from '../redux/slices/OrderSlice';

function NewCat() {
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { records } = useSelector((state) => state.posts);
  const { Loading } = useSelector(state => state.pay);
  const [currentStep, setCurrentStep] = useState(1);
  const [flag, setFlag] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [Vorname, setVorname] = useState('');
  const [title, setTitle] = useState('Herr'); // إضافة حقل title مع القيمة الافتراضية "Herr"
  const [Telefonnummer, setTelefonnummer] = useState('');
  const [StraßeHausnummer, setStraßeHausnummer] = useState('');
  const [PLZ, setPLZ] = useState('');
  const [Stadt, setStadt] = useState('');
  const [cuppon, setCuppon] = useState('');
  const [selectedPrices, setSelectedPrices] = useState([]);
  const [flag2, setFlag2] = useState(0);
  const [payedBy, setPayedBy] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('paypal');
  const [cupponStatus, setCupponStatus] = useState(false);

  const navigate = useNavigate();

  // حفظ البيانات في الجلسة
  const saveSessionData = () => {
    sessionStorage.setItem('name', name || '');
    sessionStorage.setItem('email', email || '');
    sessionStorage.setItem('Vorname', Vorname || '');
    sessionStorage.setItem('Telefonnummer', Telefonnummer || '');
    sessionStorage.setItem('StraßeHausnummer', StraßeHausnummer || '');
    sessionStorage.setItem('PLZ', PLZ || '');
    sessionStorage.setItem('Stadt', Stadt || '');
    sessionStorage.setItem('payedBy', payedBy || '');
  };
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  // بيانات الحجز
  const bookingData = {
    adultNum: Number(sessionStorage.getItem('adults')),
    date: sessionStorage.getItem('date'),
    startTime: sessionStorage.getItem('selectedTime'),
    price: Number(sessionStorage.getItem('priceFirst')),
    endTime: sessionStorage.getItem('endTime'),
    hours: Number(sessionStorage.getItem('selectedDauer'))
  };

  const priceFirst = sessionStorage.getItem('priceFirst');
  const pricefinal = Number(
    selectedPrices.reduce((sum, price) => sum + price, 0) + flag2 +
    (priceFirst * bookingData.hours)
  );

  useEffect(() => {
    dispatch(fetchposts());
  }, [dispatch]);
  const [errorFields, setErrorFields] = useState({}); // حالة لتتبع الحقول الفارغة
  // تعديل دالة validateFields لاستخدام رسائل باللغة الألمانية
  const validateFields = () => {
    const errors = {};
    if (!name) errors.name = "Bitte füllen Sie dieses Feld aus.";
    if (!Vorname) errors.Vorname = "Bitte füllen Sie dieses Feld aus.";
    if (!email) errors.email = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
    if (!Telefonnummer) errors.Telefonnummer = "Bitte geben Sie eine Telefonnummer ein.";
    if (!StraßeHausnummer) errors.StraßeHausnummer = "Bitte geben Sie Ihre Adresse ein.";
    if (!PLZ) errors.PLZ = "Bitte geben Sie Ihre Postleitzahl ein.";
    if (!Stadt) errors.Stadt = "Bitte geben Sie Ihre Stadt ein.";

    setErrorFields(errors);
    return Object.keys(errors).length === 0;
  };

  
  // الخطوة 1: اختيار الملحقات
  const renderStep1 = () => (
    <div className='w-full'>
      <h1 className='md:text-2xl text-lg my-5 font-semibold text-gray-800'>Ihre Buchung</h1>
       {/* 🆕 السكشن الجديد المنسوخ من الخطوة الثالثة */}
       <section className="my-5 w-full">
          <InfoCard />
          <ExtendedCancellationPeriod title="Verlängerte Stornierungsfrist" />
          <CancellationPeriod setPrice3={setFlag2} />
        </section>
      <div
        onClick={() => setFlag(v => !v)}
        className='cursor-pointer flex justify-between items-center border-b border-gray-400 pb-2 pr-4 hover:bg-gray-100 transition-all duration-300 rounded-lg p-2'
      >
        <h2 className='flex items-center gap-2 md:text-xl text-[14px] font-medium text-gray-900'>
          VIP-Suite
        </h2>
        <FaAngleUp
          className={`duration-500 text-2xl cursor-pointer text-gray-700 ${flag ? 'rotate-180' : 'rotate-0'}`}
        />
      </div>
  
      <motion.section
        className='overflow-hidden'
        transition={{ duration: 0.5 }}
      >
        <div className='my-4 text-gray-700 text-[14px] flex justify-between'>
          <p>Buchen Sie hier gerne unsere Extras.</p>
        </div>
  
        <section className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
          {records?.map((el) => (
            
            <Card
            key={el._id}
            img={el.categoryImage}
            Category={el.name}
            description={el.kind}
            Price={el.price}
            subCategory={el} // <-- إضافة هذا الـ prop
            addPrice={() => addPrice(el.price, el)}
            removePrice={() => removePrice(el.price, el)} // <-- تمرير الدالة
          />
              
          ))}
        </section>
  
       
  
     
        <div className="flex justify-between mt-8 mb-8">

      {/* 🆕 عرض السعر Zwischensumme */}
<h2 className="text-xl font-bold text-center mb-4">
  Zwischensumme: {pricefinal.toFixed(2)}€
</h2>
          <button
            onClick={() => setCurrentStep(2)}
            className="bg-[#a47a24] hover:bg-[#c4a15a] text-white px-6 py-2 rounded-lg flex items-center gap-2 shadow-md hover:shadow-lg transition-all duration-300"
          >
            Weiter <FaArrowRight />
          </button>
        </div>
      </motion.section>
    </div>
  );
  
 
  
  const renderStep2 = () => (
    <div className="w-full">
      <h1 className="text-2xl font-semibold mb-6">Persönliche Daten</h1>
  
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* اختيار العنوان (Herr/Frau) في نفس الصف مع الاسم */}
        <div className="w-full">
          <label className="block text-gray-700">Anrede</label>
          <div className="flex gap-2 mt-1 h-[42px]">
            <label className={`
              flex items-center justify-center px-4 py-2 rounded-lg border cursor-pointer transition-all duration-300 flex-1
              ${title === "Herr" 
                ? "border-[#a47a24] bg-[#a47a24] bg-opacity-10 text-[#a47a24] font-medium" 
                : "border-gray-300 hover:border-[#a47a24]"}
            `}>
              <input
                type="radio"
                name="title"
                value="Herr"
                checked={title === "Herr"}
                onChange={() => setTitle("Herr")}
                className="sr-only"
              />
              Herr
            </label>
            
            <label className={`
              flex items-center justify-center px-4 py-2 rounded-lg border cursor-pointer transition-all duration-300 flex-1
              ${title === "Frau" 
                ? "border-[#a47a24] bg-[#a47a24] bg-opacity-10 text-[#a47a24] font-medium" 
                : "border-gray-300 hover:border-[#a47a24]"}
            `}>
              <input
                type="radio"
                name="title"
                value="Frau"
                checked={title === "Frau"}
                onChange={() => setTitle("Frau")}
                className="sr-only"
              />
              Frau
            </label>
          </div>
        </div>
        
        {/* حقل الاسم */}
        <div className="w-full">
          <label className="block text-gray-700">Name</label>
          <input
            type="text"
            value={name}
            onChange={e => {
              const regex = new RegExp("[A-Za-zÄÖÜäöüß ]+");
              if (regex.test(e.target.value) || e.target.value === "") {
                setName(e.target.value);
              }
            }}
            onBlur={() => setErrorFields({ ...errorFields, name: !name ? `Bitte füllen Sie dieses Feld aus.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.name ? "border-red-500" : "border-gray-300"}`}
            required
            pattern="[A-Za-zÄÖÜäöüß ]+"
            title="Bitte geben Sie nur Buchstaben ein."
          />
          {errorFields.name && <p className="text-red-500 text-sm mt-1">{errorFields.name}</p>}
        </div>
        
        {/* حقل الاسم الأول */}
        <div className="w-full">
          <label className="block text-gray-700">Vorname</label>
          <input
            type="text"
            value={Vorname}
            onChange={e => {
              const regex = new RegExp("[A-Za-zÄÖÜäöüß ]+");
              if (regex.test(e.target.value) || e.target.value === "") {
                setVorname(e.target.value);
              }
            }}
            onBlur={() => setErrorFields({ ...errorFields, Vorname: !Vorname ? `Bitte füllen Sie dieses Feld aus.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.Vorname ? "border-red-500" : "border-gray-300"}`}
            required
            pattern="[A-Za-zÄÖÜäöüß ]+"
            title="Bitte geben Sie nur Buchstaben ein."
          />
          {errorFields.Vorname && <p className="text-red-500 text-sm mt-1">{errorFields.Vorname}</p>}
        </div>
        
        {/* حقل البريد الإلكتروني */}
        <div className="w-full">
          <label className="block text-gray-700">Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onBlur={() => setErrorFields({ ...errorFields, email: !email ? `Bitte geben Sie eine gültige E-Mail-Adresse ein.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.email ? "border-red-500" : "border-gray-300"}`}
            required
          />
          {errorFields.email && <p className="text-red-500 text-sm mt-1">{errorFields.email}</p>}
        </div>
        
        {/* حقل رقم الهاتف */}
        <div className="w-full">
          <label className="block text-gray-700">Telefonnummer</label>
          <input
            type="number"
            value={Telefonnummer}
            onChange={e => setTelefonnummer(e.target.value)}
            onBlur={() => setErrorFields({ ...errorFields, Telefonnummer: !Telefonnummer ? `Bitte geben Sie eine Telefonnummer ein.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.Telefonnummer ? "border-red-500" : "border-gray-300"}`}
            required
          />
          {errorFields.Telefonnummer && <p className="text-red-500 text-sm mt-1">{errorFields.Telefonnummer}</p>}
        </div>
        
        {/* حقل العنوان */}
        <div className="w-full">
          <label className="block text-gray-700">Straße Hausnummer</label>
          <input
            type="text"
            value={StraßeHausnummer}
            onChange={e => setStraßeHausnummer(e.target.value)}
            onBlur={() => setErrorFields({ ...errorFields, StraßeHausnummer: !StraßeHausnummer ? `Bitte geben Sie Ihre Adresse ein.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.StraßeHausnummer ? "border-red-500" : "border-gray-300"}`}
            required
          />
          {errorFields.StraßeHausnummer && <p className="text-red-500 text-sm mt-1">{errorFields.StraßeHausnummer}</p>}
        </div>
        
        {/* حقل الرمز البريدي */}
        <div className="w-full">
          <label className="block text-gray-700">PLZ</label>
          <input
            type="number"
            value={PLZ}
            onChange={e => setPLZ(e.target.value)}
            onBlur={() => setErrorFields({ ...errorFields, PLZ: !PLZ ? `Bitte geben Sie Ihre Postleitzahl ein.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.PLZ ? "border-red-500" : "border-gray-300"}`}
            required
          />
          {errorFields.PLZ && <p className="text-red-500 text-sm mt-1">{errorFields.PLZ}</p>}
        </div>
        
        {/* حقل المدينة */}
        <div className="w-full">
          <label className="block text-gray-700">Stadt</label>
          <input
            type="text"
            value={Stadt}
            onChange={e => setStadt(e.target.value)}
            onBlur={() => setErrorFields({ ...errorFields, Stadt: !Stadt ? `Bitte geben Sie Ihre Stadt ein.` : "" })}
            className={`w-full p-2 border rounded-lg mt-1 ${errorFields.Stadt ? "border-red-500" : "border-gray-300"}`}
            required
          />
          {errorFields.Stadt && <p className="text-red-500 text-sm mt-1">{errorFields.Stadt}</p>}
        </div>
      </div>
  
      <div className="my-5 w-full flex justify-between">
        <button
          onClick={() => setCurrentStep(1)}
          className="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded-lg flex items-center gap-2"
        >
          <FaArrowLeft /> Zurück
        </button>
  
        <button
          onClick={() => {
            if (!validateFields()) return;
            saveSessionData();
            setCurrentStep(3);
          }}
          className="bg-[#a47a24] hover:bg-[#c4a15a] text-white px-6 py-2 rounded-lg flex items-center gap-2"
        >
          Weiter <FaArrowRight />
        </button>
      </div>
    </div>
  );

  // الخطوة 3: الدفع
  const renderStep3 = () => (
    <div className="w-full">
      <h1 className="text-2xl font-semibold mb-6">Zahlungsmethode</h1>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <section className="my-5 w-full">
          <InfoCard />
          <ExtendedCancellationPeriod title="Verlängerte Stornierungsfrist" />
          <CancellationPeriod setPrice3={setFlag2} />
        </section>

        <h2 className="text-xl font-semibold mb-4">Zwischensumme: {pricefinal.toFixed(2)}€</h2>

        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setPaymentMethod('paypal')}
            className={`p-4 border-2 rounded-lg flex-1 ${
              paymentMethod === 'paypal'
                ? 'border-[#a47a24] bg-[#a47a24]/10'
                : 'border-gray-300 hover:border-[#a47a24]/50'
            }`}
          >
            <span className="font-medium">Mit PayPal bezahlen</span>
          </button>

          <button
            onClick={() => {
              setPaymentMethod('coupon');
              setCupponStatus(false); // إعادة تعيين حالة الكوبون عند التبديل
            }}
            className={`p-4 border-2 rounded-lg flex-1 ${
              paymentMethod === 'coupon'
                ? 'border-[#a47a24] bg-[#a47a24]/10'
                : 'border-gray-300 hover:border-[#a47a24]/50'
            }`}
          >
            <span className="font-medium">Gutscheincode verwenden</span>
          </button>
        </div>

        {paymentMethod === 'coupon' && (
          <div className="mb-6">
            <input
              value={cuppon}
              onChange={e => setCuppon(e.target.value)}
              className="w-full p-2 border rounded-lg mb-3"
              placeholder="Gutscheincode eingeben"
            />
            
            {/* زر التحقق من الكوبون */}
            <button
              type="button"
              onClick={() => {
                if (!cuppon) {
                  toast.error("Bitte geben Sie einen Gutscheincode ein.");
                  return;
                }
                
                dispatch(fetchCuppon({ cuppon }))
                  .unwrap()
                  .then(() => {
                    setCupponStatus(true);
                    toast.success("Gutscheincode ist gültig.");
                  })
                  .catch((error) => {
                    setCupponStatus(false);
                    toast.error("Gutscheincode ist ungültig.");
                  });
              }}
              className="w-full p-2 bg-[#a47a24] text-white rounded-lg mb-3 hover:bg-[#8a6720] transition-colors"
            >
              Gutscheincode prüfen
            </button>
          </div>
        )}
        
        <div className="mb-6">
          <label className="flex items-center gap-2">   
            <input 
              type="checkbox" 
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              className="w-4 h-4 border border-gray-400 rounded-sm accent-[#a47a24] cursor-pointer"
            />
            <span className="text-sm font-bold">
              Ich habe die allgemeine Geschäftsbedingungen gelesen und akzeptiere diese
            </span>
          </label>
          {!acceptedTerms && (
            <p className="text-red-500 text-sm mt-1">Bitte akzeptieren Sie die AGBs</p>
          )}
        </div>

        <div className="flex justify-between">
          <button
            onClick={() => setCurrentStep(2)}
            className="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded-lg flex items-center gap-2"
          >
            <FaArrowLeft /> Zurück
          </button>

          <button
            onClick={handleFinalSubmit}
            className={`px-6 py-2 rounded-lg ${
              (paymentMethod === 'coupon' && !cupponStatus) || !acceptedTerms
                ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                : 'bg-[#a47a24] hover:bg-[#c4a15a] text-white'
            }`}
            disabled={(paymentMethod === 'coupon' && !cupponStatus) || !acceptedTerms || Loading}
          >
            {Loading ? 'Wird bearbeitet...' : 'Zahlung bestätigen'}
          </button>
        </div>
      </div>
    </div>
  );

  // الدوال المساعدة
  const addPrice = (price, subCategory) => {
    if (!subCategory?._id) {
      console.error("SubCategory is missing _id:", subCategory);
      return;
    }
  
    const existingItem = selectedItems.find(item => 
      item.subCategory === subCategory._id.toString()
    );
  
    setSelectedItems(prev => {
      if (existingItem) {
        return prev.map(item =>
          item.subCategory === subCategory._id.toString()
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [
        ...prev,
        {
          subCategory: subCategory._id.toString(),
          quantity: 1,
          name: subCategory.name,
        }
      ];
    });
  
    setSelectedPrices(prev => [...prev, price]);
  };
  
  const removePrice = (price, subCategory) => {
    // التحقق من وجود subCategory و _id
    if (!subCategory || !subCategory._id) {
      console.error("Invalid subCategory object:", subCategory);
      return;
    }
  
    const existingItemIndex = selectedItems.findIndex(item => 
      item.subCategory === subCategory._id.toString()
    );
  
    if (existingItemIndex === -1) return;
  
    const updatedItems = [...selectedItems];
    const existingItem = updatedItems[existingItemIndex];
  
    if (existingItem.quantity > 1) {
      updatedItems[existingItemIndex] = {
        ...existingItem,
        quantity: existingItem.quantity - 1
      };
    } else {
      updatedItems.splice(existingItemIndex, 1);
    }
  
    setSelectedItems(updatedItems);
    
    setSelectedPrices(prev => {
      const priceIndex = prev.lastIndexOf(price);
      return prev.filter((_, index) => index !== priceIndex);
    });
  };
  // تعديل دالة handleFinalSubmit لمعالجة الدفع بشكل صحيح
  const handleFinalSubmit = async () => {
    // التحقق من قبول الشروط والأحكام
    if (!acceptedTerms) {
      toast.error("Bitte akzeptieren Sie die AGBs");
      return;
    }
    
    // التحقق من صلاحية الكوبون إذا تم اختيار طريقة الدفع بالكوبون
    if (paymentMethod === 'coupon' && !cupponStatus) {
      toast.error("Bitte überprüfen Sie zuerst den Gutscheincode.");
      return;
    }
    
    try {
      setLoading(true);
      
      const subCategories = selectedItems.length > 0 
        ? selectedItems.map(item => ({
            subCategory: item.subCategory,
            quantity: item.quantity,
            name: item.name,
          }))
        : [];

      // إذا كان الدفع بواسطة PayPal
      if (paymentMethod === 'paypal') {
        // إرسال طلب الدفع إلى PayPal
        const paymentData = {
          price: pricefinal.toFixed(2),
          currency: "EUR",
          description: `Buchung für ${bookingData.date} um ${bookingData.startTime}`
        };
        
        console.log("Sending payment request to PayPal:", paymentData);
        
        const result = await dispatch(insertPayment(paymentData)).unwrap();
        console.log("PayPal payment result:", result);
        
        // إذا كان هناك رابط للموافقة، قم بتخزين بيانات الطلب في sessionStorage
        if (result && result.approval_url) {
          // حفظ بيانات الطلب في sessionStorage لاستخدامها بعد العودة من PayPal
          const orderData = {
            title,
            name,
            vorname: Vorname,
            email,
            strabe: StraßeHausnummer,
            phoneNumber: Telefonnummer,
            plz: PLZ,
            stadi: Stadt,
            adultNum: bookingData.adultNum,
            date: bookingData.date,
            startTime: bookingData.startTime,
            endTime: bookingData.endTime,
            hours: bookingData.hours,
            price: pricefinal,
            payedBy: 'paypal',
            subCategories,
          };
          
          sessionStorage.setItem('pendingOrder', JSON.stringify(orderData));
          
          // التوجيه إلى صفحة PayPal
          window.location.href = result.approval_url;
          return;
        } else {
          throw new Error("Keine PayPal-Zahlungsseite verfügbar");
        }
      } else if (paymentMethod === 'coupon') {
        // إذا كان الدفع بواسطة الكوبون
        const orderData = {
          title,
          name,
          vorname: Vorname,
          email,
          strabe: StraßeHausnummer,
          phoneNumber: Telefonnummer,
          plz: PLZ,
          stadi: Stadt,
          adultNum: bookingData.adultNum,
          date: bookingData.date,
          startTime: bookingData.startTime,
          endTime: bookingData.endTime,
          hours: bookingData.hours,
          price: pricefinal,
          payedBy: cuppon,
          subCategories,
        };

        console.log("Sending order with coupon:", orderData);

        // إرسال البيانات إلى الباك إند
        const result = await dispatch(creatOrder(orderData)).unwrap();
        console.log("Order result:", result);
        
        if (result) {
          toast.success("Buchung erfolgreich abgeschlossen!");
          navigate('/success');
        } else {
          throw new Error("Keine Daten vom Server erhalten");
        }
      }
    } catch (error) {
      console.error("Booking error:", error);
      toast.error("Fehler bei der Buchung. Bitte versuchen Sie es später erneut.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <ToastContainer />
      <div className='w-4/5 mx-auto'>
        {currentStep === 1 && renderStep1()}
        {currentStep === 2 && renderStep2()}
        {currentStep === 3 && renderStep3()}
      </div>
    </>
  );
}

export default NewCat;



